// Module
var code = `<div class="pdf-view">
  <figure class="pdf-view__container">
    <iframe class="pdf-view__document" src="{{\$ctrl.trustedSourceUrl}}"></iframe>
  </figure>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/pdf-view/pdf-view.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;